import { ValidationType } from '@/constants/validationTypes';
import { Validation } from '../../sceneDataSchema';
import { z } from 'zod';

export function booleanValidator(
  validations: Validation[]
): z.ZodBoolean | z.ZodLiteral<true> | z.ZodNullable<z.ZodBoolean> {
  if (validations.some(({ type }) => type === ValidationType.MustBeTrue)) {
    return z.literal(true, { message: 'This field must be checked.' });
  }

  if (validations.some(({ type }) => type === ValidationType.Required)) {
    return z.boolean({ message: 'This field is required.' });
  }

  return z.boolean({ message: 'This field is required.' }).nullable();
}
